import drivewealthResource from "@/shared/resource/drivewealth";
import { authorizedAxios } from "./authorizedAxios";
import { HsaAccountStatusUpdateResponse } from "@/admin/types";

export function processHsaAccountStatusesFile ( csv: any ) {
    return authorizedAxios.postFiles<HsaAccountStatusUpdateResponse>(drivewealthResource.hsaAccountStatuses, [csv]);
}